/** Phase 5B — SCR-MER-009–018 branch settings bindings (07-02) */

export const BRANCH_SETTINGS_SCREEN_IDS = [
  'SCR-MER-009',
  'SCR-MER-010',
  'SCR-MER-011',
  'SCR-MER-012',
  'SCR-MER-013',
  'SCR-MER-014',
  'SCR-MER-015',
  'SCR-MER-016',
  'SCR-MER-017',
  'SCR-MER-018',
] as const;

export type BranchSettingsScreenId = (typeof BRANCH_SETTINGS_SCREEN_IDS)[number];

export const BRANCH_SETTINGS_ROUTES: Record<BranchSettingsScreenId, string> = {
  'SCR-MER-009': '/business-profile',
  'SCR-MER-010': '/branch-list',
  'SCR-MER-011': '/create-branch',
  'SCR-MER-012': '/branch-profile',
  'SCR-MER-013': '/opening-hours',
  'SCR-MER-014': '/special-closures',
  'SCR-MER-015': '/service-area',
  'SCR-MER-016': '/fulfilment-settings',
  'SCR-MER-017': '/capacity-settings',
  'SCR-MER-018': '/branch-status',
};

export const BRANCH_SETTINGS_PERMISSIONS: Partial<
  Record<BranchSettingsScreenId, readonly string[]>
> = {
  'SCR-MER-009': ['PERM-tenant.business.update'],
  'SCR-MER-010': ['PERM-branch.branch.read', 'PERM-branch.branch.list'],
  'SCR-MER-011': ['PERM-branch.branch.create'],
  'SCR-MER-012': ['PERM-branch.branch.update'],
  'SCR-MER-013': ['PERM-branch.hours.update'],
  'SCR-MER-014': ['PERM-branch.hours.update'],
  'SCR-MER-015': ['PERM-branch.servicearea.update'],
  'SCR-MER-016': ['PERM-branch.fulfilment.update', 'PERM-branch.branch.update'],
  'SCR-MER-017': ['PERM-branch.fulfilment.update', 'PERM-branch.preptime.update'],
  'SCR-MER-018': [
    'PERM-branch.trading.pause',
    'PERM-branch.trading.resume',
    'PERM-branch.branch.update',
  ],
};

/** Settings sub-route for substitution policy (fulfilment family). */
export const SUBSTITUTION_POLICY_PERMISSION = 'PERM-order.substitution.configure';

export const BRANCH_SETTINGS_ENDPOINTS: Partial<Record<BranchSettingsScreenId, readonly string[]>> =
  {
    'SCR-MER-009': [
      'GET /merchant/v1/business',
      'PATCH /merchant/v1/business',
      'PUT /merchant/v1/business/branding',
      'GET /merchant/v1/business/status',
    ],
    'SCR-MER-010': ['GET /merchant/v1/branches'],
    'SCR-MER-011': ['POST /merchant/v1/branches'],
    'SCR-MER-012': ['GET /merchant/v1/branches/{id}', 'PATCH /merchant/v1/branches/{id}'],
    'SCR-MER-013': [
      'GET /merchant/v1/branches/{id}/opening-hours',
      'PUT /merchant/v1/branches/{id}/opening-hours',
    ],
    'SCR-MER-014': [
      'GET /merchant/v1/branches/{id}/special-hours',
      'POST /merchant/v1/branches/{id}/special-hours',
      'DELETE /merchant/v1/branches/{id}/special-hours/{overrideId}',
    ],
    'SCR-MER-015': [
      'GET /merchant/v1/branches/{id}/service-area',
      'PUT /merchant/v1/branches/{id}/service-area',
      'POST /merchant/v1/branches/{id}/service-area/preview',
    ],
    'SCR-MER-016': ['GET /merchant/v1/branches/{id}', 'PATCH /merchant/v1/branches/{id}'],
    'SCR-MER-017': ['GET /merchant/v1/branches/{id}', 'PATCH /merchant/v1/branches/{id}/capacity'],
    'SCR-MER-018': [
      'GET /merchant/v1/branches/{id}',
      'POST /merchant/v1/branches/{id}/snooze',
      'DELETE /merchant/v1/branches/{id}/snooze',
      'POST /merchant/v1/branches/{id}/go-live',
    ],
  };

/** Phase-6 aliases living under setup nav */
export const DELIVERY_BANDS_PERMISSION = 'PERM-branch.fulfilment.update';
export const VAT_REGISTRATION_PERMISSION = 'PERM-tenant.vat.update';
export const DELIVERY_BANDS_ENDPOINTS = [
  'GET /merchant/v1/branches/{id}/delivery-bands',
  'PUT /merchant/v1/branches/{id}/delivery-bands',
] as const;
export const VAT_REGISTRATION_ENDPOINTS = [
  'GET /merchant/v1/business/vat-registration',
  'PUT /merchant/v1/business/vat-registration',
] as const;

export const BRANCH_ID_STORAGE_KEY = 'beatq.merchant.branchId';

export const WEEKDAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const;

/** 10-05a POST /branches/{id}/snooze reason enum. */
export const TRADING_PAUSE_REASONS = [
  { value: 'TOO_BUSY', label: 'Too busy' },
  { value: 'STAFF_SHORTAGE', label: 'Staff shortage' },
  { value: 'EQUIPMENT_FAILURE', label: 'Equipment failure' },
  { value: 'STOCK_SHORTAGE', label: 'Stock shortage' },
  { value: 'WEATHER', label: 'Weather' },
  { value: 'EMERGENCY', label: 'Emergency' },
  { value: 'OTHER', label: 'Other' },
] as const;

export function upcomingUkBankHolidaySuggestions(
  from: Date = new Date(),
): Array<{ date: string; label: string }> {
  const year = from.getFullYear();
  const today = from.toISOString().slice(0, 10);
  return [
    { date: `${year}-08-31`, label: 'Summer bank holiday' },
    { date: `${year}-12-25`, label: 'Christmas Day' },
    { date: `${year}-12-26`, label: 'Boxing Day' },
    { date: `${year + 1}-01-01`, label: "New Year's Day" },
  ].filter((row) => row.date >= today);
}
